import { Routes, Route } from "react-router-dom";
import { router } from ".";
import MainLayout from "../layouts/MainLayout";
const AppRouter:React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<MainLayout />}>
        {router.map(({ path, component }) => (
          <Route key={path} path={path} element={component} />
        ))}
      </Route>
    </Routes>
  );
};

export default AppRouter;
